import PropTypes from "prop-types"
import { useEveListen } from "react-eve-hook"
import { USER_GRID_CHANGED } from "../../../../Constraints"
import React, { useCallback, useState } from "react"
import _ from "ansuko"
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material"

const styles = {
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: "center",
        margin: "8px",
    },
    summary: {
        box: {
            display: "flex",
            flexDirection: "row",
            gap: "8px",
            alignItems: "center",
        },
        label: {
            fontSize: "12px",
            marginRight: "4px",
        },
        text: {
            color: "white",
        },
    },
    buttons: {
        box: {
            display: "flex",
            flexDirection: "row",
            gap: "8px",
        },
        reset: {
            border: "1px solid white",
            color: "white",
        },
        submit: {
            border: "1px solid white",
            color: "white",

            '&::disabled': {
                color: "gray",
            }
        },
    }
}

const UserListFooterView = ({ onUpdate, onReset }) => {
    
    const [edit, setEdit] = useState()
    const [openConfirmReset, setOpenConfirmReset] = useState(false)
    const [openConfirmUpdate, setOpenConfirmUpdate] = useState(false)
    const [enableSubmit, setEnableSubmit] = useState(true)

    const onSubmit = useCallback(() => {
        setOpenConfirmUpdate(false)
        onUpdate(edit)
    }, [edit])


    useEveListen(USER_GRID_CHANGED, ({ originalRows, currentRows }) => {
        
        // データvalidate
        let enable = true
        for (const row of currentRows) {
            if (_.isEmpty(row.email) && _.isEmpty(row.temp_email)) {
                enable = false
            }
        }
        setEnableSubmit(enable)

        const cur = Object.fromEntries(currentRows?.map(row => row.cartodb_id ? [row.cartodb_id, row] : null).filter(Boolean))
        const org = Object.fromEntries(originalRows?.map(row => [row.cartodb_id, row]))
        const ids = _.uniq([
            ...Object.keys(cur),
            ...Object.keys(org)
        ])

        const e = { edit: [], add: [], delete: [] }
        let edited = false

        for (const row of currentRows?.filter(v => !v.cartodb_id) ?? []) {
            e.add.push(row)
            edited = true
        }

        for (const id of ids) {
            if (!_.has(cur, id) && _.has(org, id)) {
                e.delete.push({ cartodb_id: parseInt(id), fb_uid: org[id].fb_uid})
                edited = true
            } else if (!_.has(org, id)) {
                e.add.push({ ...cur[id] })
                edited = true
            } else {
                const diff = _.changes(org[id], cur[id], ["name", "email", "password", "area"])
                if (!_.isEmpty(diff)) {
                    console.log(org[id], cur[id], diff)
                    e.edit.push({ ...diff, cartodb_id: parseInt(id), fb_uid: org[id].fb_uid })
                    edited = true
                }
            }
        }
        console.log(e)
        setEdit(edited ? e : null)
    }, [])

    if (!edit) { return null }

    return (
        <Box style={styles.root}>
            <Box style={styles.summary.box}>
                <Typography style={styles.summary.text}><span style={styles.summary.label} >追加:</span>{_.size(edit.add).toLocaleString()}件</Typography>
                <Typography style={styles.summary.text}><span style={styles.summary.label} >編集:</span>{_.size(edit.edit).toLocaleString()}件</Typography>
                <Typography style={styles.summary.text}><span style={styles.summary.label} >削除:</span>{_.size(edit.delete).toLocaleString()}件</Typography>
            </Box>
            <Box style={styles.buttons.box}>
                <Button size="small" variant="outlined" style={styles.buttons.reset} onClick={() => setOpenConfirmReset(true)}>リセット</Button>
                <Button size="small" variant="outlined" sx={styles.buttons.submit} onClick={() => setOpenConfirmUpdate(true)}>変更を保存</Button>
            </Box>
            <Dialog open={openConfirmReset} style={{zIndex: 10000}}>
                <DialogTitle>リセット</DialogTitle>
                <DialogContent>
                    <DialogContentText>未保存のデータは破棄されます。本当にリセットしますか</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirmReset(false)}>キャンセル</Button>
                    <Button onClick={() => setOpenConfirmReset(false) || onReset()} variant="secondary">リセット</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openConfirmUpdate} style={{ zIndex: 10000 }}>
                <DialogTitle>保存</DialogTitle>
                <DialogContent>
                    <DialogContentText>変更を更新します
                        <br />追加: {_.size(edit.add).toLocaleString()}件
                        <br />変更: {_.size(edit.edit).toLocaleString()}件
                        <br />削除: {_.size(edit.delete).toLocaleString()}件
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirmUpdate(false)}>キャンセル</Button>
                    <Button enable={enableSubmit} onClick={onSubmit}>変更を保存</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )

}

UserListFooterView.propTypes = {
    onUpdate: PropTypes.func,
    onReset: PropTypes.func,
}

export default UserListFooterView